import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import Menu from 'vibo-ui/Menu';
import Header from 'components/common/Header';
import GoBack from 'components/buttons/GoBack';
import Container from 'components/common/Container';

import { DEFAULT_EVENTS_TAB } from './constants';
import { EVENT_PAGE_MENU_ITEMS } from 'services/constants';
import { useEvent } from 'components/context/EventContext';
import { getSelectedEventMenuKeys } from 'services/common/routesHelper';

import { EventUserType, SessionStorageKeys } from 'types/enums';

import useHeaderStyles from 'components/common/Header/style';

const EventPageHeader: FC = () => {
  const headerClasses = useHeaderStyles();
  const { t } = useTranslation();

  const { event } = useEvent();

  const location = useLocation();
  const navigate = useNavigate();
  const match = useParams<keyof EventPageRouteParams>();

  const eTab = sessionStorage.getItem(SessionStorageKeys.eTab);
  const eQ = sessionStorage.getItem(SessionStorageKeys.eQ) ?? '';

  const isTimelineActive = location.pathname.split('/').filter(Boolean)[2] === 'timeline';

  return (
    <Header>
      <GoBack
        className={headerClasses.goBack}
        to={
          isTimelineActive
            ? `/events/${eTab ?? DEFAULT_EVENTS_TAB}${eQ ? `?q=${eQ}` : ''}`
            : `/event/${event?._id}/timeline`
        }
      />
      <Container>
        <Menu
          getSelectedSidebarMenuKeys={getSelectedEventMenuKeys}
          styleModificator="siderTop"
          mode="horizontal"
        >
          {EVENT_PAGE_MENU_ITEMS.filter(({ roles }) =>
            roles.includes(event?.role as EventUserType)
          ).map(({ name, route }) => {
            const link = `/event/${match?.id}/${route}`;

            return (
              <Menu.Item onClick={() => navigate(link)} key={link}>
                {t(name)}
              </Menu.Item>
            );
          })}
        </Menu>
      </Container>
    </Header>
  );
};

export default EventPageHeader;
